import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";

function Header({ isTransitioning, isSignIn }) {
  const { t } = useTranslation();

  return (
    <div className={`authPage__header ${isTransitioning ? "authPage__header--transitioning" : ""}`}>
      <h2 className="authPage__title">
        {isSignIn ? t("auth.titleSignIn") : t("auth.titleSignUp")}
      </h2>

      <p className="authPage__subtitle">
        {isSignIn ? t("auth.subtitleSignIn") : t("auth.subtitleSignUp")}
      </p>
    </div>
  );
}

export default Header;
